import { REHYDRATE } from 'redux-persist/lib/constants';

const initial = {
  coupons: []
};

// reducers
function eossCouponsReducer(state = initial, action) {
  switch (action.type) {
    case 'COUPON_SELECTION':
      let couponId = state.coupons.indexOf(action.coupons);
      if (couponId > -1) {
        let nextState = {
          ...state
        };
        let couponsSelected = [...nextState.coupons];
        couponsSelected.splice(couponId, 1);
        nextState.coupons = couponsSelected;

        return {
          ...nextState
        };
      }
      return {
        ...state,
        coupons: [...state.coupons, action.coupons]
      };

    case REHYDRATE:
      const { payload = {} } = action;
      const { eossCouponsReducer = {} } = payload;
      let { coupons = [] } = eossCouponsReducer;
      let nextState = {
        ...state,
        coupons: [...coupons, ...state.coupons]
      };
      return {
        ...nextState
      };

    default:
      return state;
  }
}

export default eossCouponsReducer;
